<template>
  <v-container class="sidebar--navigation">
 <v-row justify-center>
    <v-col cols="12">
      <v-card elevation="2">
        <v-row no-gutters>
          <v-col cols="4"
              :style="{ paddingTop: '100px' }"
          >
            <v-img
              v-if="product.fetched_imagesdata != ''"
              :src="getProductImage(product.fetched_imagesdata)"
              height="200"
              contain
            ></v-img>
             <v-img
                v-else
                :src="require('@/assets/images/misc/no-image.png')"
                height="200"
                contain
            ></v-img>
          </v-col>
          <v-col cols="8">
            <v-card-title class="text-h5 grey lighten-2 d-flex mb-2 mt-5">
              <v-img
                max-height="35"
                max-width="35"
                :src="require('@/assets/images/logos/etsy.png')"
              ></v-img>
              &nbsp;Product Details
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-if="product.id !== undefined">
              <v-row>
                <v-col cols="12" md="6">
                  <p class="font-weight-bold">Listing ID: {{ listing.listing_id }}</p>
                  <p class="font-weight-bold">Title: {{ product.title }}</p>
                  <p class="font-weight-bold">SKU: {{ product.sku }}</p>
                  <p class="font-weight-bold">Created On: {{ product.created_on }}</p>
                  <template >
                     <p class="font-weight-bold mt-10">Dimensions:</p>
                      <v-row>
                        <v-col cols="12">
                          <template>
                            <p class="font-weight-bold">
                              Item Length: {{listing.item_length != null ? `${listing.item_length} ${listing.item_dimensions_unit}`: 'Not Available'}}
                            </p>
                              <p class="font-weight-bold">
                              Item Breadth: {{listing.item_breadth != null ? `${listing.item_breadth} ${listing.item_dimensions_unit}`: 'Not Available'}}
                            </p>
                              <p class="font-weight-bold">
                              Item Height: {{listing.item_height != null ? `${listing.item_height} ${listing.item_dimensions_unit}`: 'Not Available'}}
                            </p>
                          </template>
                        </v-col>
                      </v-row>
                  </template>
                </v-col>

                <v-col cols="12" md="6">
                  <p class="font-weight-bold">Price: {{ listing.currency }} {{ listing.price/listing.divisor }}</p>
                  <p class="font-weight-bold">Quantity: {{ listing.quantity }}</p>
                  <p class="font-weight-bold">Who made?: {{ listing.who_made }}</p>
                  <p class="font-weight-bold">When made?: {{ listing.when_made }}</p>
                  <p class="font-weight-bold">URL: <a target="_blank" :href="listing.url">{{ listing.url }}</a></p>
                  <p class="font-weight-bold">Description: {{ JSON.parse(product.upload_result).description }}</p>

                </v-col>
              </v-row>

            </v-card-text>
            <v-card-text v-else>
              <div style="padding: 105px 0px" class="text-center">
                <h3>Something went Wrong!!</h3>
              </div>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
    </br>


    <v-card class="p-1">
      <v-card-title>
         Product Variations
      </v-card-title>

      <v-data-table :headers="headers" :items="variations" disable-pagination hide-default-footer>
        <template v-slot:body="{ items }">
          <tbody v-if="!loading_data">
            <tr v-if="!items.length">
              <td colspan="6" class="text-center" style="padding: 20px 0px">
                <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
                <p style="font-size: 25px">No Data Found!!</p>
              </td>
            </tr>
            <tr v-else v-for="item in items" :key="item.id">
              <td>
               #{{ JSON.parse(item.offerings)[0].offering_id}}
              </td>
              <td style="max-width: 300px; font-size: 12px">
              <strong>{{ item.title }}</strong>
              </td>
              <td>{{ item.sku }}</td>
              <td>
                  {{ item.quantity}}
              </td>
                <td>
                  <span v-if="JSON.parse(item.property_values).length !== 0">
                  {{ JSON.parse(item.property_values)[0].property_name }}: {{ JSON.parse(item.property_values)[0].values.join(', ') }}
                  </span>
                  <span v-else>
                    No Property
                  </span>
              </td>
              <td>
                {{ JSON.parse(item.offerings)[0].price.currency_code }}
                {{ JSON.parse(item.offerings)[0].price.amount/JSON.parse(item.offerings)[0].price.divisor }}
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="7" class="text-center" style="padding: 80px 0px">
                <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
    </br>

    <v-card class="p-1">
      <v-card-title>
        Product Media
      </v-card-title>

      <v-tabs v-model="media_tab">
        <v-tab>Images</v-tab>
        <v-tab>Videos</v-tab>
      </v-tabs>

      <v-tabs-items v-model="media_tab">
        <!-- Images Tab -->
        <v-tab-item>
          <v-card-text style="padding-top: 24px;">
            <v-row v-if="getProductImages().length > 0">
              <v-col
                v-for="(imageUrl, index) in getProductImages()"
                :key="index"
                cols="12"
                md="4"
                sm="6"
              >
                <v-img
                  :src="imageUrl"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  contain
                ></v-img>
              </v-col>
            </v-row>
            <div v-else class="text-center" style="padding: 40px 0px">
              <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
              <p style="font-size: 20px">No Images Found</p>
            </div>
          </v-card-text>
        </v-tab-item>

        <!-- Videos Tab -->
        <v-tab-item>
          <v-card-text style="padding-top: 24px;">
            <div v-if="getEtsyVideos().length > 0">
              <v-card
                v-for="(video, index) in getEtsyVideos()"
                :key="index"
                class="mb-3"
                outlined
              >
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="auto">
                      <v-avatar size="80" color="grey lighten-2">
                        <v-img
                          v-if="video.thumbnail_url"
                          :src="video.thumbnail_url"
                          contain
                        ></v-img>
                        <v-icon v-else size="40" color="primary">{{ icons.mdiPlay }}</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <p class="mb-1">
                        <strong>Video {{ index + 1 }}</strong>
                      </p>
                      <p v-if="video.width && video.height" class="text-caption grey--text mb-0">
                        Resolution: {{ video.width }}x{{ video.height }} |
                        State: {{ video.video_state || 'N/A' }}
                      </p>
                      <p v-else class="text-caption grey--text mb-0">
                        Video ID: {{ video.video_id || 'N/A' }}
                      </p>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn
                        color="primary"
                        @click="openVideoDialog(video)"
                      >
                        <v-icon left>{{ icons.mdiPlay }}</v-icon>
                        Play Video
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
            <div v-else class="text-center" style="padding: 40px 0px">
              <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
              <p style="font-size: 20px">No Videos Found</p>
            </div>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Video Popup Dialog -->
    <v-dialog v-model="video_dialog" max-width="900" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          <span>Video Player</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeVideoDialog">
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <div v-if="selected_video && getEtsyVideoUrl(selected_video)">
            <video
              :src="getEtsyVideoUrl(selected_video)"
              controls
              style="width: 100%; max-width: 100%;"
              preload="metadata"
            >
              Your browser does not support the video tag.
            </video>
          </div>
          <div v-else class="text-center pa-4">
            <p>Video URL not available</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeVideoDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>



<script>
import store from '@/store'
import { mdiChevronDown, mdiClose, mdiCheckCircle,
mdiCancel, mdiPlay } from '@mdi/js'
export default {
  data() {
    return {
      etsyProductId: null,
      product: {},
      variations: [],
      loading_data: false,
      shop: null,
      videos: [],
      video_dialog: false,
      selected_video: null,
      listing: {
        listing_id: null,
        price: null,
        divisor: 1,
        listing_type: '',
        item_length: null,
        item_breadth: null,
        item_height: null,
        item_dimensions_unit: null,
        who_made: '',
        when_made: '',
        quantity: null,
        url: ''
     },
        headers: [
        {
          text: 'Listing ID',
          value: 'listing_id',
        },
        {
          text: 'Title',
          value: 'title',
        },
        {
          text: 'SKU',
          value: 'sku',
        },
        {
          text: 'Quantity',
        },
        {
          text: 'Property',
        },
        {
          text: 'Price',
        },
      ],
      icons: {
        mdiChevronDown,
        mdiClose,
        mdiCheckCircle,
        mdiCancel,
        mdiPlay
      },
      variation_headers: [
        {
          text: 'Attributes',
        },
        { text: 'SKU' },
        { text: 'Price' },
        { text: 'Stock' },
      ],
      media_tab: 0,

    }
  },

  async mounted() {
    this.etsyProductId = this.$route.params.etsy_product_id;
    this.shop = store.getters.loggedInShop
    this.fetchEtsyProduct()
  },

  methods: {

     async fetchEtsyProduct() {
      try {
        this.loading_data = true
        let response = await axios.get(`admin/shops/${this.shop.id}/get-etsy-product/${this.etsyProductId}`, {
        })
        if (response.data.success) {
          this.product = response.data.product
          this.variations = response.data.variations == null ? [] : response.data.variations
          this.setListingData(response.data.product.upload_result)
          this.parseEtsyVideos()
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loading_data = false
      }
    },

    getProductImage(attributes) {
      try {
          if (!attributes || typeof attributes !== 'string') {
            return require('@/assets/images/misc/no-image.png');
          }
          const parsedAttributes = JSON.parse(attributes);
          if (Array.isArray(parsedAttributes) && parsedAttributes.length > 0) {
            return parsedAttributes[0].url_fullxfull;
          }
        } catch (error) {
          console.error("Error parsing attributes:", error);
        }
        return require('@/assets/images/misc/no-image.png');
    },

    getProductImages() {
      try {
        const imagesData = this.product.image_upload_result || this.product.fetched_imagesdata || [];

        if (!imagesData || typeof imagesData !== 'string') return [];

        const parsedAttributes = JSON.parse(imagesData);

        if (Array.isArray(parsedAttributes) && parsedAttributes.length > 0) {
          return parsedAttributes.map(img => img.url_fullxfull).filter(url => url);
        }

        return [];
      } catch (error) {
        console.error("Error parsing product images:", error);
        return [];
      }
    },

    setListingData(data) {
      data = JSON.parse(data)
      this.listing.price = data.price.amount;
      this.listing.divisor = data.price.divisor;
      this.listing.currency = data.price.currency_code;
      this.listing.listing_type = data.listing_type;
      this.listing.item_length = data.item_length;
      this.listing.item_breadth = data.item_width;
      this.listing.item_height = data.item_height;
      this.listing.item_dimensions_unit = data.item_dimensions_unit;
      this.listing.who_made = data.who_made;
      this.listing.when_made = data.when_made;
      this.listing.quantity = data.quantity;
      this.listing.url = data.url;
      this.listing.listing_id = data.listing_id;
    },

    parseEtsyVideos() {
      try {
        if (!this.product.videos) {
          this.videos = [];
          return;
        }
        const videosData = JSON.parse(this.product.videos);
        this.videos = Array.isArray(videosData) && videosData.length > 0 ? videosData : [];
      } catch (error) {
        console.error("Error parsing Etsy videos:", error);
        this.videos = [];
      }
    },

    getEtsyVideos() {
      return this.videos || [];
    },

    getEtsyVideoUrl(videoData) {
      return videoData?.video_url || '';
    },

    openVideoDialog(videoData) {
      this.selected_video = videoData;
      this.video_dialog = true;
    },

    closeVideoDialog() {
      this.video_dialog = false;
      this.selected_video = null;
    }

  },

}
</script>
